<div class="main_content px-3 position-relative">
  <div class="container-fluid py-3">
    <div class="title mb-4">
      <h4>Shop Summary</h4>
    </div>

    <div class="row white_box shadow">
      <div class="col-lg-12 col-md-12">
        <div class="d-flex justify-content-center">
          <select
            class="form-control year-dropdown"
            (change)="onYearChange($event)"
            [(ngModel)]="selectedYear"
          >
            <option value="" disabled selected>Select Year</option>
            <option *ngFor="let year of yearsList" value="{{ year }}">
              {{ year }}
            </option>
          </select>
          <button
            class="com_btn add-summary-btn add-summary-dialog-btn ml-auto px-2 mb-0"
            (click)="openNewSummaryModal(add_new_summary_modal)"
          >
            <i class="fas fa-plus"></i> Add Summary
          </button>
        </div>
        <nz-tabset
          [(nzSelectedIndex)]="selectedTab"
          nzType="card"
          class="mt-3"
        >
          <nz-tab
            *ngFor="let month of selectedYearMonths; let mainIndex = index"
            [nzTitle]="month.name"
            (nzClick)="onMonthSelectionChanged(month)"
          >
            <div class="table-responsive contact_new_table table_contact">
              <div class="goo_bg">
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <!-- <th scope="col">S.No.</th> -->
                      <th scope="col">Sub Admin</th>
                      <th scope="col">No. of Products</th>
                      <!-- <th scope="col">Date</th>
                      <th scope="col">Action</th> -->
                    </tr>
                  </thead>

                  <tbody>
                    <tr *ngIf="isSummariesLoading" class="text-center">
                      <td colspan="2">Loading...</td>
                    </tr>
                    <tr
                      *ngIf="!isSummariesLoading && !shopSummariesData.length"
                      class="text-center"
                    >
                      <td colspan="2">No Data Available</td>
                    </tr>
                    <tr *ngFor="let data of shopSummariesData; let i = index">
                      <!-- <th scope="row">{{ i + 1 }}</th> -->
                      <td>
                        {{ data.email }}
                      </td>
                      <td>{{ data.noOfProducts }}</td>
                      <!-- <td>{{ data.date_time }}</td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </nz-tab>
        </nz-tabset>
      </div>
    </div>
  </div>
</div>

<!-- Add new shop summary -->

<ng-template #add_new_summary_modal let-modal>
  <div>
    <div class="modal-header modal-header-title justify-content-center">
      <h4 class="modal-title">Add New Summary</h4>

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">x</a>
      <!-- <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button> -->
    </div>
    <div class="modal-body">
      <form (submit)="addNewSummary()" class="mt-n1">
        <div class="row" style="padding-top: 14px">
          <div class="col-md-12">
            <div class="nm_contact">
              <div class="form-group">
                <div class="mb-3 row">
                  <label for="name" class="col-sm-3 col-form-label"
                    >Email</label
                  >
                  <div class="col-sm-5">
                    <input
                      [(ngModel)]="formData.email"
                      type="email"
                      placeholder="Enter email"
                      class="form-control"
                      id="name"
                      name="name"
                    />
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="mb-3 row">
                  <label for="products" class="col-sm-3 col-form-label"
                    >No. of Products</label
                  >
                  <div class="col-sm-5">
                    <input
                      [(ngModel)]="formData.noOfProducts"
                      type="number"
                      placeholder="Enter no. of products"
                      class="form-control"
                      id="products"
                      name="products"
                    />
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="mb-3 row">
                  <label for="start_date" class="col-sm-3 col-form-label"
                    >Date
                  </label>
                  <div class="col-sm-5">
                    <input
                      [(ngModel)]="formData.date"
                      type="date"
                      placeholder="Enter start date"
                      class="form-control"
                      id="start_date"
                      name="start_date"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center mt-3">
              <button class="com_btn add-summary-btn px-3" type="submit">
                Add
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
